import { chainIdToFeeAssetId } from './chainIdToFeeAssetId';
export const chainIdToFeeAsset = (assetsById, chainId) => {
    const assetId = chainIdToFeeAssetId(chainId);
    return assetsById[assetId];
};
